import { Deserializable } from '../deserializable';
import { UsersSearchRequest } from './users-search-request';

export class UserAitSearchRequest
  extends UsersSearchRequest
  implements Deserializable
{
  public bankId: number;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
